import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40363a9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle mb-8" }, "Fırsat Bilgileri", -1))
const _hoisted_3 = { class: "ac-form-control w-full" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialName"
}, "Fırsat Adı", -1))
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = { class: "ac-form-control w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialType"
}, "Fırsat Önceliği", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Lütfen Bir Fırsat Önceliği Seçin", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "LOW" }, "Düşük", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "STANDARD" }, "Standart", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "HIGH" }, "Yüksek", -1))
const _hoisted_12 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "ac-form-control w-full" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialType"
}, "Fırsat Tipi", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Lütfen Bir Fırsat Türü Seçin", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "company" }, "Şirket", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "individual" }, "Bireysel", -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "ac-form-control w-full" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialCategories"
}, "Fırsat Kategorileri", -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "ac-form-control" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialRating"
}, "Fırsat Açıklaması", -1))
const _hoisted_24 = { class: "ac-form-control" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialEvaluation"
}, "Fırsat Değerlendirmesi", -1))
const _hoisted_26 = { class: "ac-form-control" }
const _hoisted_27 = { class: "date-container flex w-full gap-4" }
const _hoisted_28 = { class: "w-1/3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third-title" }, "E-Posta", -1))
const _hoisted_30 = { class: "w-1/3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third-title" }, "Telefon", -1))
const _hoisted_32 = { class: "w-1/3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third-title" }, "Web Sitesi", -1))
const _hoisted_34 = { class: "ac-form-control" }
const _hoisted_35 = { class: "reference-container w-full flex gap-4" }
const _hoisted_36 = { class: "w-full flex-col flex" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialReferrer"
}, "Keşfeden", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Lütfen Bir Kullanıcı Seçin", -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "w-full flex-col flex" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialReferrer"
}, "Aktaran Üçüncü Taraf", -1))
const _hoisted_42 = { class: "flex items-center justify-center gap-6 w-full" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "ac-primary-button text-2xl mt-8"
}, " Fırsat Oluştur ", -1))

import { ref, reactive, onBeforeMount } from "vue"
import type { AcTrackedPotential, ColorMetaField, fetchedUser } from "@/types"
import { useGetDocs } from "@/mixins/modularFirebaseOperations"
import { getAllUsers } from "@/composables/userComposables"
import Multiselect from "vue-multiselect"
import StarPicker from "@/components/reusable/starPicker.vue"


// No props needed for add-only form


export default /*#__PURE__*/_defineComponent({
  __name: 'addTrackedPotentialForm',
  emits: ["potential-added", "cancel"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const potentialName = ref("")
const potentialType = ref<"company" | "individual" | null>(null)
const potentialRating = ref(0)
const potentialDescription = ref("")
const potentialEvaluation = ref("")
const potentialPriority = ref<"LOW" | "STANDARD" | "HIGH">("STANDARD")
const selectedPotentialCategories = ref<ColorMetaField[]>([])
const referredBy = ref<fetchedUser | null>(null)
const thirdPartyRefferer = ref("")
const { docs, isLoadingDocs } = useGetDocs("crm/jobCategories/list")
const allUsers = ref<fetchedUser[]>([])
const isLoadingUsers = ref(false)

const contact = reactive({
    title: "Genel",
    emailAddress: "",
    phoneNumber: "",
    address: "",
    website: "",
})

const savePotential = async () => {
    // Validate required fields
    if (!potentialName.value.trim()) {
        alert('Lütfen fırsat adını giriniz.')
        return
    }
    
    if (!referredBy.value) {
        alert('Lütfen keşfeden kullanıcıyı seçiniz.')
        return
    }
    
    if (!potentialType.value) {
        alert('Lütfen fırsat türünü seçiniz.')
        return
    }

    const newPotential: Partial<AcTrackedPotential> = {
        title: potentialName.value,
        type: potentialType.value,
        potentialRating: potentialRating.value,
        description: potentialDescription.value,
        contact: [contact],
        potentialCategories: selectedPotentialCategories.value,
        referredBy: referredBy.value,
        thirdPartyRefferrer: thirdPartyRefferer.value,
        evaluation: potentialEvaluation.value,
        priority: potentialPriority.value,
    }

    emit("potential-added", newPotential)
}

onBeforeMount( async () => {
    await getAllUsers(allUsers.value, isLoadingUsers)
} )


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(savePotential, ["prevent"]),
    class: "ac-main-form overflow-y-auto !border-none"
  }, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createVNode(StarPicker, {
        "onUpdate:pickedQuantity": _cache[0] || (_cache[0] = ($event: any) => (potentialRating.value = $event)),
        modelValue: potentialRating.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((potentialRating).value = $event)),
        maxQuantity: 5,
        pickedQuantity: potentialRating.value
      }, null, 8, ["modelValue", "pickedQuantity"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((potentialName).value = $event)),
        type: "text",
        required: "",
        class: "w-full title-field p-3",
        id: "potentialName"
      }, null, 512), [
        [_vModelText, potentialName.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((potentialPriority).value = $event)),
          required: "",
          class: "w-full !py-3"
        }, _hoisted_12, 512), [
          [_vModelSelect, potentialPriority.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((potentialType).value = $event)),
          required: "",
          class: "w-full !py-3"
        }, _hoisted_18, 512), [
          [_vModelSelect, potentialType.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createVNode(_unref(Multiselect), {
        class: "w-full border border-[var(--accent-gray-subtle)] py-4 pl-3 border-gray-200",
        modelValue: selectedPotentialCategories.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedPotentialCategories).value = $event)),
        options: _unref(docs),
        multiple: "",
        placeholder: _unref(isLoadingDocs) ? 'İş Kategorileri Yükleniyor...' : 'Lütfen Bir İş Kategorisi Seçin',
        "track-by": "id",
        "select-label": "Seçmek için tıklayın",
        "deselect-label": "Seçimi kaldırmak için tıklayın",
        "selected-label": "Seçildi",
        label: "name"
      }, {
        tag: _withCtx(({ option, remove }) => [
          _createElementVNode("div", {
            style: _normalizeStyle({backgroundColor: option.color}),
            class: "custom-option"
          }, [
            _createElementVNode("span", null, _toDisplayString(option.name), 1),
            _createElementVNode("span", {
              class: "remove-option",
              onClick: ($event: any) => (remove(option))
            }, "x", 8, _hoisted_21)
          ], 4)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Buraya fırsatın detayları hakkında kısa bir bilgi yazabilirsiniz.",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((potentialDescription).value = $event)),
        class: "w-full p-3 h-32 resize-none"
      }, null, 512), [
        [_vModelText, potentialDescription.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Satış süreçleri, teknik detaylar kadar müşterilerin kişisel özelliklerine ve şahsi beklentilerine dayanır. Buradan fırsat hakkında daha kişisel bilgiler girerek takip süreçlerini kolaylaştırabilirsiniz.",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((potentialEvaluation).value = $event)),
        class: "w-full p-3 h-32 resize-none"
      }, null, 512), [
        [_vModelText, potentialEvaluation.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _withDirectives(_createElementVNode("input", {
            placeholder: "ad.soyad@gmail.com",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contact.emailAddress) = $event)),
            type: "email",
            class: "w-full p-3"
          }, null, 512), [
            [_vModelText, contact.emailAddress]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _withDirectives(_createElementVNode("input", {
            placeholder: "0555 555 55 55",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((contact.phoneNumber) = $event)),
            type: "tel",
            class: "w-full p-3"
          }, null, 512), [
            [_vModelText, contact.phoneNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _withDirectives(_createElementVNode("input", {
            placeholder: "https://www.sirketsitesi.com",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((contact.website) = $event)),
            type: "url",
            class: "w-full p-3"
          }, null, 512), [
            [_vModelText, contact.website]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((referredBy).value = $event)),
            required: "",
            class: "w-full !py-3"
          }, [
            _hoisted_38,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUsers.value, (user) => {
              return (_openBlock(), _createElementBlock("option", {
                key: user.id,
                value: user
              }, _toDisplayString(user.userName), 9, _hoisted_39))
            }), 128))
          ], 512), [
            [_vModelSelect, referredBy.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _withDirectives(_createElementVNode("input", {
            placeholder: "Aktaran",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((thirdPartyRefferer).value = $event)),
            type: "text"
          }, null, 512), [
            [_vModelText, thirdPartyRefferer.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _hoisted_43,
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('cancel'))),
        class: "ac-secondary-button text-2xl mt-8"
      }, "İptal")
    ])
  ], 32))
}
}

})